module.exports = __webpack_public_path__ + "static/hero-about-mobile-bec71d1beda5f0dc44924ae5a8c5752a.png";